export const VERIFY_ENABLED_CITY = 'VERIFY_ENABLED_CITY';
export const POST_REGISTER = 'POST_REGISTER';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const NOTIFY_CITY = 'NOTIFY_CITY';
export const GET_RESTO_TYPES = 'GET_RESTO_TYPES';
export const SESSION_SET_TOKEN = 'APP/SESSION_SET_TOKEN';
export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const GET_OFFERS = 'APP/GET_OFFERS';
export const DELETE_OFFER = 'APP/DELETE_OFFER';
export const SET_ERROR = 'APP/SET_ERROR';
export const SET_ERROR_CLEAN = 'APP/SET_ERROR_CLEAN';
export const UPDATE_STATUS_OFFER = 'APP/UPDATE_STATUS_OFFER';
export const GET_TEMPLATES = 'APP/GET_TEMPLATES';
export const DELETE_TEMPLATE = 'APP/DELETE_TEMPLATE';
export const UPDATE_STATUS_TEMPLATE = 'APP/UPDATE_STATUS_TEMPLATE';
export const GET_ORDERS = 'APP/GET_ORDERS';
export const GET_ORDER = 'APP/GET_ORDER';
export const UPDATE_STATUS_ORDERS = 'APP/UPDATE_STATUS_ORDERS';
export const DELETE_ORDERS = 'APP/DELETE_ORDERS';
export const CANCEL_ORDERS = 'APP/CANCEL_ORDERS';
export const GET_STORE = 'APP/GET_STORE';
export const UPDATE_STORE = 'APP/UPDATE_STORE';
export const GET_HOME = 'APP/GET_HOME';
export const UPDATE_LOGO = 'APP/UPDATE_LOGO';
export const SET_SNACKBAR = 'APP/SET_SNACKBAR';
export const HIDE_SNACKBAR = 'APP/HIDE_SNACKBAR';
export const GET_BILLING = 'APP/GET_BILLING';
export const POST_BILLING = 'APP/POST_BILLING';
export const GET_TEMPLATE = 'APP/GET_TEMPLATE';
export const CLEAN_TEMPLATE = 'APP/CLEAN_TEMPLATE';
export const SET_MEDIA_TEMPLATE = 'APP/SET_MEDIA_TEMPLATE';
export const SET_MEDIA_OFFER = 'APP/SET_MEDIA_OFFER';
export const GET_OFFER = 'APP/GET_OFFER';
export const CLEAN_OFFER = 'APP/CLEAN_OFFER';
export const GET_COMPANY = 'APP/GET_COMPANY';
export const CLEAN_COMPANY = 'APP/CLEAN_COMPANY';
export const POST_ADMIN = 'APP/POST_ADMIN';
export const ERROR_GET_COMPANY = 'APP/ERROR_GET_COMPANY';
export const GET_PAST_ORDERS = 'APP/GET_PAST_ORDERS';
export const GET_PAYMENTS = 'APP/GET_PAYMENTS';
export const GET_SUMMARIES = 'APP/GET_SUMMARIES';
export const GET_MANAGEMENT_INFO = 'APP/GET_MANAGEMENT_INFO';
export const GET_MANAGEMENT_SALES = 'APP/GET_MANAGEMENT_SALES';
export const GET_MANAGEMENT_CUSTOMERS = 'APP/GET_MANAGEMENT_CUSTOMERS';
export const GET_RATINGS = 'APP/GET_RATINGS';
export const SET_AS_TEMPLATE_ID = 'APP/SET_AS_TEMPLATE_ID';
export const SET_TAB_TEMPLATE = 'APP/SET_TAB_TEMPLATE';
export const GET_ORDER_ERROR = 'APP/GET_ORDER_ERROR';
export const CLEAN_HOME = 'APP/CLEAN_HOME';
export const IS_OPENING_HOME = 'APP/IS_OPENING_HOME';
export const GET_NOTIFICATIONS = 'APP/GET_NOTIFICATIONS';
export const ADD_NOTIFICATION = 'APP/ADD_NOTIFICATION';
export const UPDATE_TERMS = 'APP/UPDATE_TERMS';
export const SHOW_LOADING = 'APP/SHOW_LOADING';
export const HIDE_LOADING = 'APP/HIDE_LOADING';
export const CHANGE_QTY = 'APP/CHANGE_QTY';
export const SET_OFFER_ID_TEMP = 'APP/SET_OFFER_ID_TEMP';
export const GET_NOTIFICATIONS_EDIT = 'APP/GET_NOTIFICATIONS_EDIT';
export const POST_NOTIFICATION = 'APP/POST_NOTIFICATION';

export const MESSAGE_OK = "Successfully saved";